import type {RouteRecordRaw} from 'vue-router';
import BaseCompany from '@/components/company/index.vue';
import type {CommonRouteMeta} from '@/types/common';

const lazyPayView = () => import('@/views/pay/ThePaymentView.vue');

const payRoutes: RouteRecordRaw[] = [
    {
        path: '/pay',
        component: BaseCompany,
        meta: {
            hidden: true,
            noCache: false,
            requiresAuth: false,
            middleware: ['companyStore'],
            layout: 'Default',
        } as CommonRouteMeta,
        children: [
            {
                path: ':p_id',
                component: lazyPayView,
                name: 'pay',
                meta: {title: 'single payment', icon: 'mdi-account-outline', noCache: false} as CommonRouteMeta,
            },
        ],
    }
];

export default payRoutes;
